(() => {
  const API_BASE = window.COLOR_APP_BASE ||
                   'https://color-swatches-app-production.up.railway.app';
  const collectionId = window.COLLECTION_ID;
  if (!collectionId) return;

  const detectMarket = () => {
    const raw =
      window.Shopify?.country ||
      window.Shopify?.localization?.country?.iso_code ||
      document.documentElement.lang?.split('-').pop() ||
      '';
    const country = (raw || '').toLowerCase().trim();
    return country === 'us' ? 'us' : 'ca';
  };

  const canon = str =>
    (str || '').trim().replace(/^_+/, '').replace(/\s+/g, ' ').toLowerCase();

  const markCard = (cardEl, soldOut = []) => {
    const soldOutSet = new Set(soldOut.map(canon));

    cardEl.querySelectorAll('.color-swatch[data-color]').forEach(sw => {
      if (soldOutSet.has(canon(sw.dataset.color))) {
        sw.style.display = 'none';
        sw.dataset.hide = '1';
        sw.classList.remove('active');
      } else {
        sw.style.display = '';
        delete sw.dataset.hide;
      }
    });

    if (!cardEl.querySelector('.color-swatch.active:not([data-hide])')) {
      const first = cardEl.querySelector('.color-swatch:not([data-hide])');
      if (first) first.classList.add('active');
    }

    const hasVisible = cardEl.querySelector('.color-swatch:not([data-hide])');
    const title = cardEl.querySelector('.product-card__title')?.textContent || '';
    const isBundle = /pack|bundle/i.test(title);

    if (!hasVisible && !isBundle) {
      cardEl.style.display = 'none';
      cardEl.dataset.hideCard = '1';
    } else {
      cardEl.style.display = '';
      delete cardEl.dataset.hideCard;
    }
  };

  const applyInventoryMap = data => {
    window.__collectionInventoryCache = data;

    document.querySelectorAll('.product-card[data-product-id]')
      .forEach(card => {
        let pid = card.dataset.productId;
        if (pid.includes("gid://")) pid = pid.split("/").pop();
        pid = pid.trim();

        const inv = data[pid];
        markCard(card, inv?.sold_out_colors || []);
        if (!inv || !inv.variant_qty) return;

        let totalProductQty = 0;

        for (const [variantId, qty] of Object.entries(inv.variant_qty)) {
          const rawColor = (inv.variant_color?.[variantId] || '').trim();
          if (rawColor.startsWith('_')) continue;
          const num = Number(qty);
          if (num > 0) totalProductQty += num;
        }

        const title = card.querySelector('.product-card__title')?.textContent || '';
        const isBundle = /pack|bundle/i.test(title);

        let badge = card.querySelector('.limited-stock-badge');

        if (isBundle) {
          if (badge) badge.style.display = 'none';
          return;
        }

        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'limited-stock-badge';
          badge.textContent = 'Limited Stock';
          (card.querySelector('.product-card__image') || card).appendChild(badge);
        }

        badge.style.display =
          (totalProductQty > 0 && totalProductQty <= 75)
            ? 'block'
            : 'none';

        const variantEl = card.querySelector('.product-card__variant-color');
        const current = variantEl?.textContent.trim().toLowerCase();

        const available = Array.from(
          card.querySelectorAll('.color-swatch:not([data-hide])')
        );

        if (
          available.length &&
          !available.some(sw => sw.dataset.color.trim().toLowerCase() === current)
        ) {
          card.querySelectorAll('.color-swatch.active').forEach(sw =>
            sw.classList.remove('active')
          );

          setTimeout(() => {
            available[0].dispatchEvent(
              new MouseEvent('click', { bubbles: true, cancelable: true })
            );
          }, 0);
        }
      });

    document.body.dataset.inventoryReady = '1';
  };

  const market = detectMarket();
  const invUrl =
    `${API_BASE}/inventory/collection?collectionId=${collectionId}&market=${market}`;

  const invPromise = window.__invPromise
    ? Promise.resolve(window.__invPromise)
    : fetch(invUrl)
        .then(r => r.json())
        .then(data => (window.__invPromise = data));

  invPromise.then(applyInventoryMap).catch(console.error);

  new MutationObserver(muts => {
    if (!window.__collectionInventoryCache) return;

    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (
          n.nodeType === 1 &&
          (n.matches('.product-card') || n.querySelector('.product-card'))
        ) {
          applyInventoryMap(window.__collectionInventoryCache);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
